// Shared helpers for optional multi-company CRM scoping.

export const UNASSIGNED_COMPANY_ID = "__unassigned__";

export function companyQueryParams({ usesCompanies, companyId, includeUnassigned }) {
  if (!usesCompanies) return {};
  if (includeUnassigned || companyId === UNASSIGNED_COMPANY_ID) {
    return { unassigned: "true" };
  }
  if (companyId) return { companyId: String(companyId) };
  return {};
}

export function formatCompany(c) {
  if (!c) return "—";
  if (c.id === UNASSIGNED_COMPANY_ID || c._id === UNASSIGNED_COMPANY_ID) return "Unassigned";
  return c.name || "Untitled company";
}
